import { Component, OnInit } from '@angular/core';
import { ResultDto } from 'src/app/model/result-dto';
import { HttpclientService } from 'src/app/services/httpclient.service';

@Component({
  selector: 'app-cancel-zcra-zdra',
  templateUrl: './cancel-zcra-zdra.component.html',
  styleUrls: ['./cancel-zcra-zdra.component.css']
})

export class CancelZcraZdra implements OnInit {

  updateStatus: String;
  createModalPopup;
  puchaseOrderNumberBoxModal;
  data;
  isAxaltaCartKeyUpdated: boolean;
  updatedAxaltaCartKey;
  AxaltaCartKey: String;  
  AxaltaCartKeyExist: String;  
  purchaseOrderNumber: String;
  documentTypeCodeId: String;
  responseStatus: String;
  AxaltaCartKeyForStatus: String;

  constructor(private httpclientService: HttpclientService) { 

    this.documentTypeCodeId = "ZCRA";
   }
  
  ngOnInit() {
  }

  clearZCRA_ZDRA()
  {    
    this.data = [];    
    this.createModalPopup = false;
    console.log( "1 :: "+this.AxaltaCartKey + " "+this.purchaseOrderNumber +" "+this.documentTypeCodeId);

    this.httpclientService.updateClearZcraZdra(this.AxaltaCartKey, this.purchaseOrderNumber, this.documentTypeCodeId ).subscribe(
      
       data => {
         this.data = data;
         console.log(this.data);
        console.log( this.AxaltaCartKey + " "+this.purchaseOrderNumber +" "+this.documentTypeCodeId);

         console.log("Status : " + this.data[0].status); 
         this.responseStatus =  this.data[0].status;
         this.AxaltaCartKeyExist = this.data[0].AxaltaCartKeyExist;
         this.AxaltaCartKeyForStatus = this.AxaltaCartKey;

         if(this.data[0].AxaltaCartKeyExist == 'Y')
         {
           this.isAxaltaCartKeyUpdated = true;
           console.log(" isAxaltaCartKeyUpdated "+this.isAxaltaCartKeyUpdated);
         }
         else{
          this.isAxaltaCartKeyUpdated = false;
          console.log(" isAxaltaCartKeyUpdated "+this.isAxaltaCartKeyUpdated);
         }

      }
    );
    
  }

  openPopupCancelZcraZdra() {
    this.createModalPopup = true;
  }

  pressingCancel() {
    this.createModalPopup = false;
  }
}
